<template>
  <div id="app" class="wrapper">
    <div class="main-panel">
      <app-header v-if="!noHeader"></app-header>
      <div class="content pl-30" id="content">
        <router-view />
        <iphone-frame-preview v-if="hasIphoneContainer"></iphone-frame-preview>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  components: {
    appHeader: Header,
  },
  computed: {
    noHeader() {
      return this.$route.name == "Signin";
    },
    hasIphoneContainer() {
      const page = this.$route.name
      return page == 'Graph' || page == 'Dashboard'
    },
  },
};

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

Array.prototype.last = function() {
  return this[this.length - 1];
};

String.prototype.abbr = function() {
  return this.split(" ")
    .map((item) => item[0])
    .join("")
    .toUpperCase();
};
</script>

<style>
html, body {
  line-height: unset;
}

.table-responsive {
  overflow: unset;
}

.pl-30 {
  padding-left: 30px !important;
}

.flex1 {
  flex: 1
}

.bg-black {
  background-color: black;
}

.bold {
  font-weight: bold;
}

.cursor {
  cursor: pointer
}

.errorBox {
  color: red
}

.cursor{
  color: rgb(109, 109, 200);
  cursor: pointer
}
</style>
